"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tag = _interopRequireDefault(require("../tag/tag"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OverviewHeader = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(OverviewHeader, _React$PureComponent);

  var _super = _createSuper(OverviewHeader);

  function OverviewHeader() {
    var _this;

    _classCallCheck(this, OverviewHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "buildTag", function () {
      var _this$props = _this.props,
          tag = _this$props.tag,
          customTagProps = _this$props.customTagProps;

      var tagProps = _objectSpread({
        theme: tag
      }, customTagProps);

      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ml12 inline-block relative",
        style: {
          top: '-7px'
        }
      }, /*#__PURE__*/_react.default.createElement(_tag.default, tagProps));
    });

    return _this;
  }

  _createClass(OverviewHeader, [{
    key: "renderVersion",
    value: function renderVersion() {
      var props = this.props;

      var versionEl = props.version !== undefined && /*#__PURE__*/_react.default.createElement("span", {
        className: "inline-block mr6"
      }, "Current version: ", /*#__PURE__*/_react.default.createElement("code", null, "v", props.version), ' ');

      var changelogLinkEl = props.changelogLink && /*#__PURE__*/_react.default.createElement("a", {
        className: (0, _classnames.default)('unprose link txt-underline', {
          'link--white': props.lightText
        }),
        href: props.changelogLink
      }, "View changelog");

      if (!versionEl && !changelogLinkEl) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("p", null, versionEl, changelogLinkEl);
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var props = this.props;
      var btnClasses = (0, _classnames.default)('btn txt-l round inline-block unprose mr24', {
        'btn--white color-gray-dark': props.lightText,
        'btn--blue': !props.lightText
      });

      var installLinkEl = props.installLink && /*#__PURE__*/_react.default.createElement("a", {
        href: props.installLink,
        className: btnClasses
      }, "Install");

      var ghLinkEl = props.ghLink && /*#__PURE__*/_react.default.createElement("a", {
        href: props.ghLink,
        className: (0, _classnames.default)('inline-block unprose link', {
          'link--white': props.lightText
        })
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "flex-parent flex-parent--center-cross"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "flex-child mr6"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "github",
        inline: true
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "flex-child"
      }, "Contribute on GitHub")));

      var contactLinkEl = props.contactLink && /*#__PURE__*/_react.default.createElement("a", {
        href: props.contactLink,
        className: btnClasses
      }, "Contact us");

      if (!installLinkEl && !ghLinkEl && !contactLinkEl) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mb24"
      }, installLinkEl, contactLinkEl, ghLinkEl);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var featuresList = props.features ? props.features.map(function (feature, index) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: index,
          className: "ml-neg24 flex-parent"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "flex-child flex-child--no-shrink mr6 m3 color-gray-light"
        }, /*#__PURE__*/_react.default.createElement(_icon.default, {
          name: "check",
          inline: true
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "flex-child flex-child--grow"
        }, feature));
      }) : undefined;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("dr-ui--overview-header prose mb24 pr60-mxl ".concat(props.theme), {
          'border-b border--darken10': !props.theme,
          'round py12 px24': props.theme,
          'color-white': props.lightText
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-parent flex-parent--center-cross"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-child flex-child--grow"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "mb6 txt-fancy"
      }, props.title, props.tag && this.buildTag(props)), props.description && /*#__PURE__*/_react.default.createElement("p", {
        className: "txt-l"
      }, props.description), this.renderVersion(), featuresList && /*#__PURE__*/_react.default.createElement("ul", {
        className: "unprose mb24 ml24"
      }, featuresList), this.renderFooter()), props.image && /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-child-ml flex-child--no-shrink w300-mxl align-r"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "none block-mxl"
      }, props.image))));
    }
  }]);

  return OverviewHeader;
}(_react.default.PureComponent);

OverviewHeader.defaultProps = {
  lightText: false
};
OverviewHeader.propTypes = {
  /** features of the product */
  features: _propTypes.default.arrayOf(_propTypes.default.string),

  /** description of the product */
  description: _propTypes.default.string,

  /** title of the product */
  title: _propTypes.default.string.isRequired,
  tag: _propTypes.default.oneOf(['legacy', 'beta', 'fundamentals', 'new', 'custom']),

  /* Required if tag is set to `custom` */
  customTagProps: _propTypes.default.shape({
    customLabel: _propTypes.default.string.isRequired,
    customTooltipText: _propTypes.default.string.isRequired,
    customStyles: _propTypes.default.shape({
      background: _propTypes.default.string.isRequired,
      color: _propTypes.default.string.isRequired,
      borderColor: _propTypes.default.string.isRequired
    }).isRequired
  }),

  /** image of the product */
  image: _propTypes.default.node,

  /** version number of the product */
  version: _propTypes.default.string,

  /** creates a "View changelog" link */
  changelogLink: _propTypes.default.string,

  /** creates an "Install" button */
  installLink: _propTypes.default.string,

  /** creates a "Contribute on GitHub" link */
  ghLink: _propTypes.default.string,

  /** creates a "Contact us" button */
  contactLink: _propTypes.default.string,

  /** Classes to apply to the OverviewHeader containter, usually an Assembly background color: https://labs.mapbox.com/assembly/documentation/#Background-colors */
  theme: _propTypes.default.string,

  /** If `true`, the component will use white text */
  lightText: _propTypes.default.bool
};
var _default = OverviewHeader;
exports.default = _default;